<template>
    <div>
        <!-- Preview Markdown -->
        <div class="modal fade" id="previewMarkDownModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Preview</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="mb-3">
                            <a href="#" @click.prevent="edicao = 'E'">Editar</a>

                            <az-input   
                                v-if="false"
                                sizing="sm"
                                type="button-group"
                                :optionsList="[
                                    { id: 'P', search: 'Preview' }, 
                                    { id: 'E', search: 'Edição' }
                                ]"
                                optionsData="id"
                                v-model="edicao" />
                        </div>

                        <table class="table small">
                            <tr>
                                <td>Texto</td>
                                <td>Formatado</td>
                            </tr>
                            <tr>
                                <td class="table-secondary" width="50%">
                                    <az-input 
                                        type="textarea"
                                        v-model="texto" 
                                        rows="15"
                                        v-if="edicao == 'E'" />

                                    <div v-else style="white-space: pre-wrap;">{{ texto }}</div>
                                </td>
                                <td class="table-success" width="50%">
                                    <vue-markdown :source="texto" v-if="edicao == 'E'" />
                                    <span v-html="texto_html" v-else></span>
                                </td>
                            </tr>
                        </table>

                        <div class="alert alert-info" v-if="edicao == 'E'" style="white-space: pre-wrap;"># - Título 1
## - Título 2
### - Título 3
__Texto__ ou **Texto** para Negrito
*Texto* para Itálico
--- (3 hífens) para traçar uma linha horizontal
 
1. A
2. B
3. C
Para gerar uma lista numerada.

- A
- B
- C
Para gerar uma lista de itens.</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" v-if="edicao == 'E'" @click="atualizar()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import VueMarkdown from 'vue-markdown'
import AzInput from './forms/AzInput.vue';

export default {
    data() {
        return { 
            texto: "",
            texto_html: "", 
            model: null, 
            edicao: "P", 
            campo: "", 
        };
    },

    components: { 
        VueMarkdown, 
        AzInput,
    },

    methods: { 
        atualizar () { 
            this.$set(this.model, this.campo, this.texto);
            $('#previewMarkDownModal').modal('hide');
        },

        abrir (model, campo) { 

            this.edicao = 'P'; 
            this.model = model;
            this.campo = campo; 
            this.texto = model[campo];

            $('#previewMarkDownModal').modal('show');

            this.$util.atualizar(this, { 
                service: 'instrucoes',
                func: 'preview_markdown',
                dados: { 
                    texto: this.texto,
                },
                callback: res => { 
                    this.texto_html = res.texto_html;
                }
            });

        }
    }
}
</script>
